export const getPseudoRandomId = () => Math.round(Math.random() * 10000);
